import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorHandlerService, HandleError } from '../shared/http-error-handler.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ForuscareService } from '../foruscare/foruscare.service';
import { Account } from '../../models/account';
import { ServiceProvider } from '../../models/service-provider';


@Injectable({
  providedIn: 'root'
})
export class ServiceProviderService {

  private handleError: HandleError;
  constructor(
    public http: HttpClient,
    public fourscareService: ForuscareService,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handleError = httpErrorHandler.createHandleError('Service Provider Service');
  }

  createServiceProvider(serviceProvider: ServiceProvider): any {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/serviceProvider", serviceProvider)
      .pipe(
        catchError(this.handleError('service provider creation'))
      );
  }

  updateServiceProvider(serviceProvider: ServiceProvider): any {
    return this.http.put<any>(this.fourscareService.baseAuthURL() + "/serviceProvider/" + serviceProvider.id, serviceProvider)
      .pipe(
        catchError(this.handleError('service provider updation'))
      );
  }

  getExistingProviders(): any {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/serviceProvider")
      .pipe(
        catchError(this.handleError('listing existing service providers'))
      );
  }
  getAllExistingProviders(): any {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/serviceProvider/getAllProvidersBasicInfo")
      .pipe(
        catchError(this.handleError('listing existing service providers'))
      );
  }
  getAllProviders(): any {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/serviceProvider/getAllProvidersBasicInfo")
      .pipe(
        catchError(this.handleError('listing existing service providers'))
      );
  }
  getExistingProvidersPaging(count, offset): any {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/serviceProvider?count=" + count + "&offset=" + offset)
      .pipe(
        catchError(this.handleError('listing existing service providers'))
      );
  }
  getExistingProviderByOrgId(orgId: any): any {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/serviceProvider/providerInfoByOrgId/" + orgId)
      .pipe(
        catchError(this.handleError('listing existing service providers'))
      );
  }

  uploadServiceProviderLogo(formData: any, providerId: any): Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/serviceProvider/uploadLogo/" + providerId, formData)
      .pipe(
        catchError(this.handleError("service provider logo upload"))
      );
  }
  addUpdateProviderKeyConfiguration(accountId, congigData) {
    return this.http.put<any>(this.fourscareService.baseAuthURL() + "/admin/organizationconfig/addConfig/" + accountId, congigData)
      .pipe(
        catchError(this.handleError("service provider logo upload"))
      );
  }
  getProviderKeyConfigurationByAcountId(accountId) {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/admin/organizationconfig/getConfig/" + accountId)
      .pipe(
        catchError(this.handleError('listing existing service providers'))
      );
  }
  /*getCameraToken(cameraId,cameraCode){
    var reqObj={
      "cameraId":cameraId,
      "cameraCode":cameraCode
    }
    return this.http.post<any>(this.fourscareService.hostUrl + "/ForusSmartAI/eyenuk/v1/generateCameraToken" ,JSON.stringify(reqObj))
      .pipe(
        catchError(this.handleError("fetch camera token"))
      );
  }*/
  getCameraToken(cameraIdValue: String, cameraCodeValue: String, accountIdvalue: any, orgIdValue: any): any {
    var reqObj = {
      cameraID: cameraIdValue,
      cameraCode: cameraCodeValue,
      accountId: accountIdvalue,
      orgId: orgIdValue
    }
    return this.http.post<any>(this.fourscareService.aiHostUrl + "/ForusSmartAI/eyenuk/v1/generateCameraToken", reqObj)
      .pipe(
        catchError(this.handleError("fetch camera token"))
      );
  }
  getBlobURLtobase64(blobURL: string) {
    var blobURLObj = {
      url: blobURL
    }
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/util/getBlobData/", blobURLObj)
      .pipe(
        catchError(this.handleError('blob image error'))
      );
  }

}
